import React from "react";

function Footer(props) {
  return (
    <div className="footer">
      <p>Ⓒ Anshu Sharma</p>
    </div>
  );
}

export default Footer;
